import { Box, Typography } from "@mui/material";

interface DetailRowProps {
    icon: string;
    label: string;
    required?: boolean;
    error?: boolean;
    children: React.ReactNode;
  }
  
  const DetailRow: React.FC<DetailRowProps> = ({ 
    icon, 
    label, 
    required, 
    children 
  }) => (
    <Box className="detail-row">
      <img src={icon} alt={label} className="detail-icon" />
      <Typography variant="body2" className="detail-label">
        {label} {required && <span style={{ color: "red" }}>*</span>}
      </Typography>
      {children}
    </Box>
  );

 export default DetailRow